import { combineReducers } from "redux";
import productBouquetReducer from "./ProductBouquet";
import transactionJourneyReducer from "./TransactionJourney";
import orderBookReducer from "./OrderBook";
import registerLeadReducer from "./RegisterLead";
export default combineReducers({
    productBouquetReducer: productBouquetReducer,
    transactionJourneyReducer: transactionJourneyReducer,
    orderBookReducer: orderBookReducer,
    registerLeadReducer: registerLeadReducer,
});
